<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle class="py-0" :caret="false" aria-label="Account">
      <!-- Not CAvatar's `src`: CAvatar builds its own <img> and forwards no
           listeners to it, so @error would land on the wrapper and never fire. -->
      <CAvatar size="md" status="success">
        <img :src="avatar" class="avatar-img" alt="" @error="fallback" />
      </CAvatar>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownHeader component="h6" class="dropdown-header bg-light dark:bg-white dark:bg-opacity-10 py-2">
        Account
      </CDropdownHeader>
      <CDropdownItem class="cursor-pointer" @click="logout">
        <CIcon icon="cil-lock-locked" /> Logout
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import defaultAvatar from '@/assets/images/avatars/default.jpg'
import { endpoint, logout } from '@/libraries/oauth'
import { useAuthStore } from '@/stores/auth'
import { error } from '@/libraries/toast'

export default defineComponent({
  name: 'HeaderDropdownAccount',
  data() {
    return {
      avatar: defaultAvatar,
    }
  },
  mounted() {
    this.image()
  },
  methods: {
    image() {
      endpoint().then((response) => {
        if (!response || !response.picture) return
        this.avatar = response.picture
      })
    },
    /* The picture is served by the identity provider: the CSP img-src list may block its
       host, or it may be gone, so fall back to the bundled avatar. */
    fallback(): void {
      this.avatar = defaultAvatar
    },
    logout() {
      logout().then((response) => {
        useAuthStore().reset()
        if (response && response.success) {
          window.location.href = '/'
          return
        }
        error('Could not reach the server: your session may still be open.')
      })
    },
  },
})
</script>
